import { FormApi } from 'final-form';
import React, { useState } from 'react';
import { LoginPayload } from 'store/api/types';

import { LoginProps } from './Login.types';
import { LoginForm } from './loginForm/LoginForm';

export const Login = ({ onLogin, onSetToken, location, history, ...rest }: LoginProps) => {
  const [isSubmitFailed, setSubmitFailed] = useState(false);

  const handleSubmit = async (values: LoginPayload, formApi: FormApi) => {
    try {
      return await onLogin(values, formApi, ({ payload: { access_token, refresh_token, expires_in } }) => {
        onSetToken(access_token, refresh_token, expires_in);
        history.push('/');
      });
    } catch (error) {
      setSubmitFailed(true);
    }
  };

  return <LoginForm {...rest} onSubmit={handleSubmit} isSubmitFailed={isSubmitFailed} />;
};
